import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n        max-width: ",
        "%;\n        flex: 0 0 ",
        "%;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      ",
        "\n\n      ",
        "\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n      ",
        ":first-child {\n        order: 2;\n        padding-left: 8.33%;\n        position: relative;\n\n        ",
        "\n      }\n\n      ",
        ":last-child {\n        ",
        "\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled, { css } from "styled-components";
import Box from "../layout/Box";
var normalizeAlign = function(align) {
    if (align === "top") {
        return "flex-start";
    }
    if (align === "bottom") {
        return "flex-end";
    }
    return align;
};
export var GridColumn = styled(Box).withConfig({
    componentId: "sc-30b12ff1-0"
})(_templateObject2(), function(param) {
    var theme = param.theme, _size = param.size, size = _size === void 0 ? 1 : _size, _columns = param.columns, columns = _columns === void 0 ? 1 : _columns;
    var columnWidth;
    if (columns) {
        columnWidth = (100 / columns * size).toFixed(2);
    }
    return css(_templateObject1(), theme.mq.small({
        maxWidth: "100%",
        flex: "0 0 100%"
    }), columnWidth && css(_templateObject(), columnWidth, columnWidth));
});
var GridBase = function(_param) {
    var children = _param.children, _align = _param.align, align = _align === void 0 ? "center" : _align, columns = _param.columns, _columnsSizes = _param.// define possibility to have bigger columns
    columnsSizes, columnsSizes = _columnsSizes === void 0 ? [] : _columnsSizes, // avoid passing `isRtl` to HTML elements
    _isRtl = _param.isRtl, restProps = _object_without_properties(_param, [
        "children",
        "align",
        "columns",
        "columnsSizes",
        "isRtl"
    ]);
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        $mx: [
            null,
            -10,
            -10,
            -10
        ],
        $styles: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: normalizeAlign(align)
        }
    }, restProps), {
        children: React.Children.map(children, function(child, index) {
            return /*#__PURE__*/ _jsx(GridColumn, {
                columns: columns,
                size: columnsSizes[index] || 1,
                $px: [
                    null,
                    10,
                    10,
                    10
                ],
                $styles: {
                    maxWidth: [
                        "100%",
                        null,
                        null,
                        null
                    ],
                    flex: [
                        "0 0 100%",
                        null,
                        null,
                        null
                    ]
                },
                children: child
            });
        })
    }));
};
var Grid = styled(GridBase).withConfig({
    componentId: "sc-30b12ff1-1"
})(_templateObject4(), function(param) {
    var isRtl = param.isRtl;
    return isRtl && css(_templateObject3(), GridColumn, function(param) {
        var theme = param.theme;
        return theme.normalizeStyles({
            left: [
                null,
                10,
                10,
                10
            ],
            order: [
                1,
                2,
                2,
                2
            ],
            paddingLeft: [
                0,
                "8.33%",
                "8.33%",
                "8.33%"
            ]
        });
    }, GridColumn, function(param) {
        var theme = param.theme;
        return theme.normalizeStyles({
            order: [
                2,
                1,
                1,
                1
            ]
        });
    });
});
export default Grid;
